// Age is derived from the date of birth ('YYYY-MM-DD') so it stays current.
// Mirrors backend/utils/birthDate.js.

export const MIN_AGE = 18;
export const MAX_AGE = 120;

const pad = (n) => String(n).padStart(2, '0');
const toISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// Whole years from birth date to `today`; null if it isn't a 'YYYY-MM-DD' date.
export const ageFromBirthDate = (birthDate, today = new Date()) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthDate || '');
  if (!m) return null;
  const [year, month, day] = [Number(m[1]), Number(m[2]), Number(m[3])];
  let age = today.getFullYear() - year;
  if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) age -= 1;
  return age;
};

// min/max for <input type="date"> so only ages MIN_AGE–MAX_AGE can be picked.
export const birthDateBounds = (today = new Date()) => ({
  min: toISO(new Date(today.getFullYear() - MAX_AGE, today.getMonth(), today.getDate())),
  max: toISO(new Date(today.getFullYear() - MIN_AGE, today.getMonth(), today.getDate())),
});

// Validation message for a birth date field, or '' when it's acceptable.
export const birthDateError = (birthDate) => {
  if (!birthDate) return 'Date of birth is required';
  const age = ageFromBirthDate(birthDate);
  if (age === null) return 'Enter a valid date';
  if (age < MIN_AGE || age > MAX_AGE) return `Age must be between ${MIN_AGE} and ${MAX_AGE}`;
  return '';
};

// Age for display: from the birth date when there is one, otherwise the age
// stored at signup (accounts created before birthdays were collected).
export const currentAge = (user) => ageFromBirthDate(user?.birth_date) ?? user?.age ?? null;
